import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'

/**
 * 安全地渲染全局错误信息到 body。
 * 使用 DOM API 与 textContent，避免 innerHTML 引入 XSS。
 */
function showFatalError(title: string, details: string[]) {
  const container = document.createElement('div')
  container.style.padding = '20px'
  container.style.color = 'red'

  const heading = document.createElement('h2')
  heading.textContent = title
  container.appendChild(heading)

  details.forEach((line) => {
    const pre = document.createElement('pre')
    pre.textContent = line
    container.appendChild(pre)
  })

  document.body.innerHTML = ''
  document.body.appendChild(container)
}

// Global error handler to catch runtime errors
window.onerror = (message, source, lineno, colno, error) => {
  console.error('Global error:', { message, source, lineno, colno, error });
  showFatalError('Runtime Error', [
    String(message),
    `at ${source}:${lineno}:${colno}`,
    error?.stack ? String(error.stack) : '',
  ])
}

window.onunhandledrejection = (event) => {
  console.error('Unhandled promise rejection:', event.reason);
  showFatalError('Promise Error', [String(event.reason)])
}

try {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>,
  )
} catch (error) {
  console.error('Failed to render app:', error)
  showFatalError('Render Error', [String(error)])
}
